import { render, staticRenderFns } from "./ModalContainer.vue?vue&type=template&id=4b481758&"
import script from "./ModalContainer.vue?vue&type=script&lang=ts&"
export * from "./ModalContainer.vue?vue&type=script&lang=ts&"
import style0 from "./ModalContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports